<template>
	<div class="alphabet-view">
		<div @click="goto(null)" :class="{ char: true, active: !index }">{{ all }}</div>
		<div @click="goto(c)" :class="{ char: true, round: true, active: c == index }" v-for="c in alphabet" :key="c">{{ c }}</div>
	</div>
</template>

<script>
	const all = 'Alle';
	const alphabet = 'abcdefghijklmnopqrstuvwxyzæøå';

	export default {
		props: {
			index: {
				type: String,
				default: null
			}
		},
		data: () => {
			return {
				alphabet,
				all
			}
		},
		methods: {
			goto(index) {
				if (index === this.index) {
					return;
				}

				this.$emit('update:index', index);
			}
		}
	}
</script>

<style lang="scss" scoped>
	$size: 30px;

	.alphabet-view {
		& > .char {
			display: inline-block;
			
			height: $size;
			line-height: $size;
			text-align: center;
			border: 1px solid #ccc;
			border-radius: calc(#{$size} / 2);
			cursor: pointer;
			padding: 0 15px 0 15px;
			margin-right: 5px;
			font-size: 12px;
			text-transform: uppercase;

			&.round {
				padding: 0;
				width: $size;
			}

			&.active {
				background-color: #f7223f;
				color: white;
				border-color: #f7223f;
			}
		}
	}
</style>